import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from './Header';
import Footer from './Footer';
import UploadTerminaliComponent from './UploadTerminaliComponent';
import { LayoutDashboard, Users, FileText, BarChart3, Settings, LogOut } from 'lucide-react';

const DashboardAdmin = () => {
  const { user, logout, isAuthenticated, isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated || !isAdmin) {
      navigate('/login-crm');
    }
  }, [isAuthenticated, isAdmin, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (!user) return null;

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col">
      <Header />
      
      <div className="flex-grow container mx-auto px-4 pt-48 pb-8">
        {/* Welcome Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 mb-8 text-white">
          <h1 className="text-3xl font-bold mb-2">Benvenuto, {user.nome} {user.cognome}!</h1>
          <p className="text-blue-100">Dashboard Amministratore CRM - Lovecchio Group</p>
          <button
            onClick={handleLogout}
            className="mt-4 px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition-colors duration-200 flex items-center space-x-2"
          >
            <LogOut size={16} />
            <span>Logout</span>
          </button>
        </div>

        {/* Stats Grid */}
        <div className="grid md:grid-cols-4 gap-6 mb-8">
          <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-gray-400 text-sm font-medium">Utenti Totali</h3>
              <Users className="w-8 h-8 text-blue-400" />
            </div>
            <p className="text-3xl font-bold text-white">0</p>
            <p className="text-xs text-gray-500 mt-2">Da implementare</p>
          </div>

          <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-gray-400 text-sm font-medium">Lead Attivi</h3>
              <FileText className="w-8 h-8 text-green-400" />
            </div>
            <p className="text-3xl font-bold text-white">0</p>
            <p className="text-xs text-gray-500 mt-2">Da implementare</p>
          </div>

          <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-gray-400 text-sm font-medium">Opportunità</h3>
              <BarChart3 className="w-8 h-8 text-orange-400" />
            </div>
            <p className="text-3xl font-bold text-white">0</p>
            <p className="text-xs text-gray-500 mt-2">Da implementare</p>
          </div>

          <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-gray-400 text-sm font-medium">Clienti</h3>
              <Users className="w-8 h-8 text-purple-400" />
            </div>
            <p className="text-3xl font-bold text-white">0</p>
            <p className="text-xs text-gray-500 mt-2">Da implementare</p>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
          <h2 className="text-xl font-bold text-white mb-4 flex items-center">
            <Settings className="w-6 h-6 mr-2 text-orange-400" />
            Azioni Rapide
          </h2>
          <div className="grid md:grid-cols-3 gap-4">
            <button className="p-4 bg-gray-700 hover:bg-gray-600 rounded-lg text-left transition-colors duration-200">
              <h3 className="font-semibold text-white mb-1">Gestione Utenti</h3>
              <p className="text-sm text-gray-400">Crea e gestisci utenti CRM</p>
            </button>
            <button className="p-4 bg-gray-700 hover:bg-gray-600 rounded-lg text-left transition-colors duration-200">
              <h3 className="font-semibold text-white mb-1">Visualizza Lead</h3>
              <p className="text-sm text-gray-400">Tutti i lead e preventivi</p>
            </button>
            <button className="p-4 bg-gray-700 hover:bg-gray-600 rounded-lg text-left transition-colors duration-200">
              <h3 className="font-semibold text-white mb-1">Report</h3>
              <p className="text-sm text-gray-400">Analytics e statistiche</p>
            </button>
          </div>
        </div>

        {/* Upload Terminali Section */}
        <div className="mb-8">
          <UploadTerminaliComponent token={localStorage.getItem('access_token')} />
        </div>

        {/* Info Box */}
        <div className="mt-8 bg-blue-500/10 border border-blue-500/50 rounded-xl p-6">
          <h3 className="text-lg font-semibold text-blue-400 mb-2">🚀 Gestione Terminali Attiva!</h3>
          <p className="text-gray-300">
            Carica il file Excel con i terminali disponibili. I terminali verranno automaticamente aggiunti al listino TERMINALI
            e saranno disponibili per essere associati ai lead.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DashboardAdmin;
